import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ThemeToggle from './ThemeToggle';

const navItems = [
  { name: 'Competition', href: '#competition' },
  { name: 'Schedule', href: '#schedule' },
  { name: 'Speakers', href: '#speakers' },
  { name: 'Sponsors', href: '#sponsors' },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background/90 dark:bg-dark-bg/90 backdrop-blur-md border-b border-border dark:border-dark-border'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="section-container">
        <div className="flex justify-between h-16 items-center">
          {/* Logo */}
          <a href="#home" className="flex-shrink-0 flex items-center gap-2 group">
            <img src="/irdo-dark.png" alt="IRDO" className="h-8 w-auto hidden dark:block transition-transform duration-300 group-hover:scale-105" />
            <img src="/irdo-light.png" alt="IRDO" className="h-8 w-auto block dark:hidden transition-transform duration-300 group-hover:scale-105" />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="relative px-3 py-2 rounded-btn text-sm font-medium text-text-secondary dark:text-dark-text-secondary hover:text-text-primary dark:hover:text-dark-text-primary transition-colors duration-200 group"
              >
                {item.name}
                {/* Hover underline */}
                <span className="absolute bottom-1 left-3 right-3 h-[2px] bg-accent dark:bg-dark-accent scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />
              </a>
            ))}
            <div className="ml-3 pl-3 border-l border-border dark:border-dark-border flex items-center gap-3">
              <ThemeToggle />
              <a
                href="#register"
                className="btn-primary !h-9 px-4 text-xs hover:bg-accent dark:hover:bg-dark-accent transition-colors duration-200"
              >
                Register
              </a>
            </div>
          </div>

          {/* Mobile: theme + hamburger */}
          <div className="flex items-center gap-3 md:hidden">
            <ThemeToggle />
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="p-2 text-text-primary dark:text-dark-text-primary hover:bg-surface-secondary dark:hover:bg-dark-surface-secondary rounded-btn transition-colors focus:outline-none focus:ring-2 focus:ring-accent/50"
              aria-label="Toggle menu"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                {mobileOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            className="md:hidden border-t border-border dark:border-dark-border bg-background dark:bg-dark-bg"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
          >
            <div className="section-container py-4 space-y-1">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="block px-3 py-2.5 rounded-btn text-sm font-medium text-text-primary dark:text-dark-text-primary hover:bg-surface-secondary dark:hover:bg-dark-surface-secondary transition-all border-l-2 border-transparent hover:border-accent dark:hover:border-dark-accent"
                >
                  {item.name}
                </a>
              ))}
              <a
                href="#register"
                onClick={() => setMobileOpen(false)}
                className="btn-primary w-full mt-2"
              >
                Register
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;